export async function ProcessPaypalTranscation(
  Rank: string,
  PermWeapon1: string,
  PermWeapon2: string,
  Steamid64: string
): Promise<StripeCheckoutSessionDetails> {
  var postdata: StripeSessionCreationClass = {
    RankName: Rank,
    PermWeapon1: PermWeapon1,
    PermWeapon2: PermWeapon2,
    STEAMID64: Steamid64,
    PaymentType: "Paypal",
  };

  return fetch("https://api.pandahut.net/api/PaymentProcessing/Session", {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    method: "post",
    body: JSON.stringify(postdata),
  })
    .then((res) => res.json())
    .then((data: any) => {
      console.log(`We got ${data} and are returning ${data.id}`);
      var data2 = JSON.parse(data);
      console.log(`We got ${data2} and are returning ${data2.id}`);

      return data2;
    });
}

export interface StripeSessionCreationClass {
  RankName: string;
  PermWeapon1: string;
  PermWeapon2: string;
  STEAMID64: string;
  PaymentType: string;
}

// Generated by https://quicktype.io

export interface StripeCheckoutSessionDetails {
  id: string | null;
  error: null | boolean;
  message: null | string;
}

export interface Metadata {}

export interface TotalDetails {
  amount_discount: number;
  amount_tax: number;
  breakdown: null;
}
